import { spaceCadet } from '@cogneed/react-utils';
import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)(() => ({
  backgroundColor: '#fff',
  borderRadius: 4,
  margin: '0px 8px',
  padding: '8px 12px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: 4,
  '& .MuiTypography-h3': {
    fontSize: 14,
    lineHeight: '20px',
    color: spaceCadet[600],
    fontWeight: 700,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  '& .MuiTypography-h4': {
    fontSize: 8,
    lineHeight: '16px',
    color: spaceCadet[400],
    '& strong': {
      color: spaceCadet[500],
    },
  },
}));

export default StyledBox;
